export const fsaProducts = {
  prefix: 'fsa',
  iconName: 'fsaProducts',
  icon: [
    576,
    512,
    [],
    null,
    'M290.7 48.3c-1.7-.6-3.6-.6-5.4 0l-81.2 29L288 109.5l83.9-32.1-81.2-29zM176 207.2l88 31.4V151.7l-88-33.7v89.3zm136 31.4l88-31.4V117.9l-88 33.7v86.9zM448 93V207.5l91.9 34.8c21.8 8.2 36.1 29.1 36.1 52.4V413.9c0 22.2-13.1 42.3-33.5 51.3l-96.4 42.4c-14 6.1-29.8 6.3-43.9 .5L288 460.7 173.8 508c-14.1 5.8-30 5.7-43.9-.5L33.5 465.1C13.1 456.2 0 436.1 0 413.9V294.7c0-23.3 14.4-44.1 36.1-52.4L128 207.5V93c0-23.7 14.9-44.8 37.2-52.7l104-37.1c12.2-4.3 25.5-4.3 37.6 0l104 37.1C433.1 48.2 448 69.3 448 93zM264 320.2l-88 33.7V455.1l88-36.4V320.2zM52.8 421.2L128 454.3V353.9L48 323.2v90.7c0 3.2 1.9 6 4.8 7.3zM400 455.1V353.9l-88-33.7v98.6l88 36.4zm48-.9l75.2-33.1c2.9-1.3 4.8-4.2 4.8-7.3V323.2l-80 30.6V454.3zM155 250.7c-1.8-.6-3.7-.6-5.5 .1L70.8 280.6 152 311.7l83.9-32.1L155 250.7zm266 0l-80.9 28.9L424 311.7l81.2-31.1-78.7-29.8c-1.8-.7-3.7-.7-5.5-.1z',
  ],
};
